// frontend/shared/src/tg.ts —— Telegram WebApp 桥（S-61；只读 window.Telegram，不加载脚本）
export interface TgWebApp {
  initData: string;
  initDataUnsafe?: { user?: { id: number; username?: string; first_name?: string; language_code?: string }; start_param?: string };
  platform?: string;
  ready(): void;
  expand?(): void;
  close?(): void;
  setHeaderColor?(c: string): void;
  setBackgroundColor?(c: string): void;
  BackButton?: { show(): void; hide(): void; onClick(fn: () => void): void; offClick(fn: () => void): void };
  HapticFeedback?: { notificationOccurred(k: 'error' | 'success' | 'warning'): void; impactOccurred(k: 'light' | 'medium' | 'heavy'): void };
  openTelegramLink?(url: string): void;
}

interface TgWindow {
  Telegram?: { WebApp?: TgWebApp };
}

function hasTelegram(w: object): w is TgWindow {
  return 'Telegram' in w;
}

// 与原型 tg() 判定一致：platform 存在且不为 unknown
export function getTg(w: object = globalThis): TgWebApp | null {
  try {
    if (!hasTelegram(w)) return null;
    const tg = w.Telegram?.WebApp;
    return tg && tg.platform && tg.platform !== 'unknown' ? tg : null;
  } catch {
    return null;
  }
}

// miniapp 形态 = TG 环境且带非空 initData（浏览器内打开的 t.me 链接没有 initData）
export function isMiniApp(w: object = globalThis): boolean {
  const tg = getTg(w);
  return !!tg && typeof tg.initData === 'string' && tg.initData.length > 0;
}

export function haptic(kind: 'error' | 'success'): void {
  try {
    getTg()?.HapticFeedback?.notificationOccurred(kind);
  } catch {
    // 旧版客户端无 HapticFeedback 或调用抛错时忽略：触感反馈非关键路径
  }
}
